import { useState } from 'react';
import { AttendanceScope, Registration } from '../API';
import { usePartyAttendance } from '../hooks/usePartyAttendance';
import { activePeople } from '../utils/partyAttendance';
import '../css/PartyAttendance.css';

export function PartyScanActions({ party, onChange }: { party: Registration; onChange: (party: Registration) => void }) {
  const [selected, setSelected] = useState<string[]>([]);
  const { run, retry, busy, pending, error } = usePartyAttendance(party, onChange);
  const people = activePeople(party);
  const selectedIds = selected.filter(id => people.some(p => p.attendeeId === id && !p.isCheckedIn));
  const disabled = busy || !!pending || ['CANCELLED', 'DELETED'].includes(party.registrationStatus);
  return <div className="party-scan-actions">
    <p>{party.checkedInCount ?? 0} / {party.guests ?? 0} checked in</p>
    <details><summary>Choose people to check in ({selectedIds.length} selected)</summary>
      {people.map(person => <label key={person.attendeeId}><input type="checkbox"
        disabled={disabled || person.isCheckedIn} checked={selectedIds.includes(person.attendeeId)}
        onChange={e => setSelected(previous => e.target.checked ? [...previous.filter(id => id !== person.attendeeId), person.attendeeId] : previous.filter(id => id !== person.attendeeId))} />
        {person.firstName} {person.lastName} ({person.role === 'PRIMARY' ? 'Primary registrant' : 'Guest'}){person.isCheckedIn ? ' — checked in' : ''}</label>)}
    </details>
    <button disabled={disabled || !selectedIds.length} onClick={() => void run({ scope: AttendanceScope.SELECTED, checkedIn: true, attendeeIds: selectedIds })}>Check in selected</button>
    <button disabled={disabled || !people.some(p => !p.isCheckedIn)} onClick={() => void run({ scope: AttendanceScope.PARTY, checkedIn: true })}>Check in all</button>
    {busy && <p role="status">Saving…</p>}{error && <p role="alert">{error}</p>}
    {pending && !busy && <button onClick={() => void retry()}>Retry last action</button>}
  </div>;
}
